<template>
  <v-container fluid class="alert-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Alert</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="9"><p class="text-h5">New Alert</p></v-col>
                  </v-row>
                  <v-row justify="center" style="margin-top: -10px;">
                    <v-col cols="12" md="3">
                      <v-text-field
                        class="mb-4"
                        v-model="alert.alertcode"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Alert Code"
                        persistent-hint
                        single-line hint="Enter the alert Code">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                          class="mb-4"
                          v-model="alert.alertname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Alert Name"
                          persistent-hint
                          single-line hint="Enter the alert name">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="alert.alerttype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the alert type">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <v-form>
                        <label>
                          <h6>Alert Subject</h6> 
                        </label>
                        <v-text-field
                          class="mb-4"
                          v-model="alert.alertsubject"
                          v-bind:error="errorindex == 3"
                          dense
                          placeholder="Subject"
                        >
                        </v-text-field>
                        <label>
                          <h6>Alert Sms</h6> 
                        </label>
                        <v-text-field
                          class="mb-4"
                          v-model="alert.alertsms"
                          v-bind:error="errorindex == 4"
                          dense
                          placeholder="Sms"
                        >
                        </v-text-field>
                        <label>
                          <h6>Alert Email</h6> 
                        </label>
                        <vue-editor v-model="alert.alertemail"></vue-editor>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/alert/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertAlert()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {VueEditor} from "vue2-editor";
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      step: 1,
      alert: {
        alertstatus: 'Active'
      },
      items: ['Alert', 'Other Alert'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Alert', ['insertAlertRequest', 'getAlertsRequest']),
    checkError(){
      if(!this.alert.alertcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.alert.alertname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.alert.alerttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.alert.alertsubject){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.alert.alertsms){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    insertAlert() {
      if(!this.checkError()) return;
      this.insertAlertRequest(this.alert);
      this.getAlertsRequest();
      router.push('/alert/list');
    },
  },
  computed: {
    ...mapState('Alert', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
